import { userInfo } from "os";
import { useDispatch } from "react-redux";
import { Status, UserDetails } from "../../types/user";
import { updateCreateNewStaffField } from "../../features/user/userSlice";
import { Role } from "../../types/masterData";

export const useStaffPopulate = (userInfo: UserDetails | undefined, roles: Role[], status: Status[]) => {

    const dispatch = useDispatch()
    
    const populateStaffInfo = () => {

        if(!userInfo) return;
        
        const matchedRole = roles.find((r) => r.roleId === userInfo?.roleId);
        const matchedStatus = status.find((s) => Number(s.statusId) === Number(userInfo?.statusId));
        
        dispatch(updateCreateNewStaffField({ field: "firstName", value: userInfo.firstName }));
        dispatch(updateCreateNewStaffField({ field: "middleInitial", value: userInfo.middleInitial || "" }));
        dispatch(updateCreateNewStaffField({ field: "lastName", value: userInfo.lastName }));
        dispatch(updateCreateNewStaffField({ field: "email", value: userInfo.email }));
        dispatch(updateCreateNewStaffField({ field: "role", value: matchedRole || null }));
        dispatch(updateCreateNewStaffField({ field: "password", value: "" }));
        dispatch(updateCreateNewStaffField({ field: "status", value: matchedStatus || null }));

    }

    return { 
        populateStaffInfo 
    }
}